export default function centerTruncate(str, x = 6, y = 4) {
    if (!str)
        return "";
    if (x + y >= str?.length) {
        // If x + y is greater than or equal to the length of the string, return the original string
        return str;
    }
    const start = str.slice(0, x);
    const end = str.slice(-y);
    return `${start}...${end}`;
}
